import Field from '../Field.jsx';
import FieldGroup from '../FieldGroup.jsx';

export default function WirexSection({ wirex, set }) {
  const setW = (field, value) => set(`wirex.${field}`, value);
  return (
    <FieldGroup
      title="Wirex model assumptions"
      caption="Detailed rail assumptions used by the forecast."
    >
      <Field
        label="Y1 card revenue share"
        value={wirex.interchangeShareY1}
        pct
        step={0.01}
        onChange={(v) => setW('interchangeShareY1', v)}
      />
      <Field
        label="Tier 1 share"
        value={wirex.tier1Share}
        pct
        step={0.01}
        onChange={(v) => setW('tier1Share', v)}
      />
      <Field
        label="Tier 2 share"
        value={wirex.tier2Share}
        pct
        step={0.01}
        onChange={(v) => setW('tier2Share', v)}
      />
      <Field
        label="Tier 3 share"
        value={wirex.tier3Share}
        pct
        step={0.01}
        onChange={(v) => setW('tier3Share', v)}
      />
      <Field
        label="Tier 1 cap ($)"
        value={wirex.tier1Cap}
        step={1_000_000}
        onChange={(v) => setW('tier1Cap', v)}
      />
      <Field
        label="Tier 2 cap ($)"
        value={wirex.tier2Cap}
        step={1_000_000}
        onChange={(v) => setW('tier2Cap', v)}
      />
      <Field
        label="FX passthrough rate"
        value={wirex.fxPassThrough}
        pct
        step={0.001}
        onChange={(v) => setW('fxPassThrough', v)}
      />
      <Field
        label="Integration fee"
        value={wirex.integrationFee}
        step={500}
        onChange={(v) => setW('integrationFee', v)}
      />
      <Field
        label="KYC verification fee"
        value={wirex.kycVerificationFee}
        step={0.5}
        onChange={(v) => setW('kycVerificationFee', v)}
      />
      <Field
        label="Monthly fee Y1"
        value={wirex.floorY1}
        step={500}
        onChange={(v) => setW('floorY1', v)}
      />
      <Field
        label="Monthly fee Y2"
        value={wirex.floorY2}
        step={500}
        onChange={(v) => setW('floorY2', v)}
      />
      <Field
        label="Monthly fee Y3"
        value={wirex.floorY3}
        step={500}
        onChange={(v) => setW('floorY3', v)}
      />
      <Field
        label="Dispute fee"
        value={wirex.disputeFee}
        step={1}
        onChange={(v) => setW('disputeFee', v)}
      />
      <Field
        label="Disputes per 1,000 tx"
        value={wirex.disputesPer1000Tx}
        step={0.1}
        decimals={1}
        onChange={(v) => setW('disputesPer1000Tx', v)}
      />
      <Field
        label="Transactions per cardholder / mo"
        value={wirex.transactionsPerCardholderMo}
        step={1}
        onChange={(v) => setW('transactionsPerCardholderMo', v)}
      />
      <Field
        label="Physical card MOQ"
        value={wirex.physicalCardMoq}
        step={500}
        onChange={(v) => setW('physicalCardMoq', v)}
      />
      <Field
        label="Earn yield share · TBD pending Q(a)"
        value={wirex.earnYieldPartnerShare}
        pct
        step={0.01}
        onChange={(v) => setW('earnYieldPartnerShare', v)}
      />
      <Field
        label="Exchange fee rate · TBD pending Q(b)"
        value={wirex.exchangeFeeRate}
        pct
        step={0.001}
        onChange={(v) => setW('exchangeFeeRate', v)}
      />
    </FieldGroup>
  );
}
